export default {
  SET_TENANT (state, payload) {
    state.tenant = Object.assign({}, state.tenant, payload) //precisa ser assim para manter a reatividade
  },
  DELETE_TENANT (state) {
    state.tenant = null
  }
}
